"use client";
import { LiveSharePage } from "@highway/design-system";

export default function LiveShare() {
    return (
        <>
            <title>Amortization</title>
            <LiveSharePage
                tool="amort"
                baseUrl="amortization"
                renderHeaderText={({ clientName }) => `Mortgage Amortization for ${clientName}`}
                renderButtonText={({ isMeeting }) => (isMeeting ? "View amortization" : "View flyer")}
                hasReportRoute
            />
        </>
    );
}
